import { render, staticRenderFns } from "./mobileDetail.vue?vue&type=template&id=31fd6aca"
import script from "./mobileDetail.vue?vue&type=script&lang=js"
export * from "./mobileDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fd6aca')) {
      api.createRecord('31fd6aca', component.options)
    } else {
      api.reload('31fd6aca', component.options)
    }
    module.hot.accept("./mobileDetail.vue?vue&type=template&id=31fd6aca", function () {
      api.rerender('31fd6aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/mobileDetail.vue"
export default component.exports